module.exports = {
    list: [
        // {
        //     module: {
        //         name: '日志查询',
        //         id: 'LogQuery',
        //         pic: require("@/assets/img/LogQuery.png"),
        //         picActive: require("@/assets/img/LogQuery_active.png"),
        //     }
        // },
        // {
        //     module: {
        //         name: '类别管理',
        //         id: 'Category',
        //         pic: require("@/assets/img/LogQuery.png"),
        //         picActive: require("@/assets/img/LogQuery_active.png"),
        //     }
        // }
        // ,
        // {
        //     module: {
        //         name: '文章管理',
        //         id: 'Category',
        //         pic: require("@/assets/img/LogQuery.png"),
        //         picActive: require("@/assets/img/LogQuery_active.png"),
        //     }
        // },
        {
            module: {
                name: 'banner管理',
                id: 'Category',
                pic: require("@/assets/img/LogQuery.png"),
                picActive: require("@/assets/img/LogQuery_active.png"),
            }
        },
        {
            module: {
                name: '视频管理',
                id: 'Video',
                pic: require("@/assets/img/LogQuery.png"),
                picActive: require("@/assets/img/LogQuery_active.png"),
            }
        },
        {
            module: {
                name: '志愿者活动',
                id: 'Aavolunteer',
                pic: require("@/assets/img/LogQuery.png"),
                picActive: require("@/assets/img/LogQuery_active.png"),
            }
        },
         {
            module: {
                name: '文章管理',
                id: 'Article',
                pic: require("@/assets/img/LogQuery.png"),
                picActive: require("@/assets/img/LogQuery_active.png"),
            }
        }
        // ,
        // {
        //     module: {
        //         name: '测试上传',
        //         id: 'upload',
        //         piclogin: require("@/assets/img/LogQuery.png"),
        //         picActive: require("@/assets/img/LogQuery_active.png"),
        //     }
        // }
    ],
    list2: [],
    list3: [],
    cache_expired_in: 86400, // localStorage 缓存数据过期时间，秒
    apiUrl:
    {
        // dev: 'http://localhost:930/',
        // test: 'http://localhost:930/',
        // prod: 'http://localhost:930/'
        dev: 'https://qian.chindee.com/',
        test: 'https://qian.chindee.com/',
        prod: 'https://qian.chindee.com/'
        // dev: 'http://192.168.0.146:930/',
        // test: 'http://192.168.0.146:930/',
        // prod: 'http://192.168.0.146:930/'
    }
    ,
    originUrl: {
        // dev: 'http://localhost:930/',
        // test: 'http://localhost:930/',
        // prod: 'http://localhost:930/'
        dev: 'https://qian.chindee.com/',
        test: 'https://qian.chindee.com/',
        prod: 'https://qian.chindee.com/'
        // dev: 'http://192.168.1.13:930/',
        // test: 'http://192.168.1.13:930/',
        // prod: 'http://192.168.1.13:930/'
    }
    ,
    qiniu: {
        // 正式
        bucketHost: 'https://xcxqn.chindee.com/',
        // 测试
        // bucketHost: '',
    },
}
